@if(periodData && periodData.length > 0){
  <app-cards-basic title="{{ 'PERIODS.title' | translate:{ count: 0 } }}">
    <mat-chip-listbox class="statistic-selection" aria-label="Statistic selection">
      @for (period of periodData; track period.id) {
        <mat-chip-option matTooltip="{{period.start_date}} – {{period.end_date}}"
                         [selected]="period.id === selectedPeriod?.id"
                         (click)="selectPeriod(period)">
          {{ period.translations[currentLanguage].title }}
        </mat-chip-option>
      }
    </mat-chip-listbox>
  </app-cards-basic>
}
